<template>
    <div>
        <header class="g-hd f-bcf">
            <img class="back" @click="backward()" src="../../assets/jxwx/arr_02.png" alt=""> {{data.name | nameP}}医生绩效明细
        </header>
        <ul class="performanceBox f-dfsb">
                <li class="f-tal">
                    <div class="tt f-fs2 f-cl1">本月绩效累计(元)</div>
                    <div class="f-fs8">{{data.MonthFee | moneyP}}</div>
                </li>
                <li class="f-tar">
                    <div class="tt f-fs2 f-cl1">昨日绩效(元)</div>
                    <div class="f-cl2 f-fs8">{{data.todayMoney | moneyP}}</div>
                </li>
            </ul>
        <ul class="m-detailsList f-bcf">
            <li>
                <div class="itemName">绩效项</div>
                <div class="cumMonth">本月累计</div>
                <div class="yesPer">
                    <div>昨日绩效</div>
                </div>
            </li>
            <li @click="toChargeItemDetails('诊查费')">
                <div class="itemName">诊查费</div>
                <div class="cumMonth">{{data.monthDetail.examinationFee | moneyP}}</div>
                <div class="yesPer">
                    <div class="f-cl2">{{data.dayDetail.examinationFee | moneyP}}</div>
                </div>
            </li>
            <li @click="toChargeItemDetails('收住院')">
                <div class="itemName">收住院</div>
                <div class="cumMonth">{{data.monthDetail.inpatientNumFee | moneyP}}</div>
                <div class="yesPer">
                    <div class="f-cl2">{{data.dayDetail.inpatientNumFee | moneyP}}</div>
                </div>
            </li>
            <li  @click="toChargeItemDetails('检查开单')">
                <div class="itemName">检查开单</div>
                <div class="cumMonth">{{data.monthDetail.checkorderFee | moneyP}}</div>
                <div class="yesPer">
                    <div class="f-cl2">{{data.dayDetail.checkorderFee | moneyP}}</div>
                </div>
            </li>
            <li @click="toChargeItemDetails('手术费')">
                <div class="itemName">手术费</div>
                <div class="cumMonth">{{data.monthDetail.operationFee | moneyP}}</div>
                <div class="yesPer">
                    <div class="f-cl2">{{data.dayDetail.operationFee | moneyP}}</div>
                </div>
            </li>
            <li @click="toChargeItemDetails('检查相关')">
                <div class="itemName">检查相关</div>
                <div class="cumMonth">{{data.monthDetail.checkrelatedFee | moneyP}}</div>
                <div class="yesPer">
                    <div class="f-cl2">{{data.dayDetail.checkrelatedFee | moneyP}}</div>
                </div>
            </li>
            <li @click="toChargeItemDetails('单项统计')">
                <div class="itemName">单项统计</div>
                <div class="cumMonth">{{data.monthDetail.singleFee | moneyP}}</div>
                <div class="yesPer">
                    <div class="f-cl2">{{data.dayDetail.singleFee | moneyP}}</div>
                </div>
            </li>
        </ul>
        
    </div>
</template>

<script>
import api from "@/axios/api";
export default {
    data() {
        return {
            data:this.$route.query.data,
            date:this.$route.query.date
        }
    },
    filters: {
        nameP: function(value) {
            if (value) {
                return value.split("(")[0];
            }
        }
    },
    mounted() {},
    methods: {
        backward() {
            this.$router.backward();
            // alert(this.$route.params.isBack)
        },
        toChargeItemDetails(name) {
                this.$router.replace({
                    path: "/jxwx/chargeItemDetails",
                    query: {
                        name: name,
                        date:this.date,
                        data:this.data,
                    }
                });
        },
    }
};
</script>

<style lang="less" scoped>
.g-hd {
    display: flex;
    align-items: center;
    height: 13.3vw;
    margin: 0 4.8vw;
    border-bottom: 1px solid #dedede;
    .back {
        width: 2vw;
        font-size: 16px;
        margin-right: 2.6vw;
    }
    .tt {
        margin-left: 4vw;
    }
}
.performanceBox {
    margin: 0 4.8vw;
    padding: 3.2vw 0 1.8vw 0;
    li {
        padding: 1.3vw 0;
        .tt {
            margin-bottom: 2.6vw;
        }
    }
}
.m-detailsList {
    li {
        position: relative;
        display: flex;
        align-items: center;
        height: 14.5vw;
        margin: 0 4vw;
        font-size: 15px;
        border-bottom: 1px solid #dedede;
        div {
            flex: 1;
            text-align: center;
        }
        .itemName {
            text-align: left;
        }
        .yesPer {
            text-align: right;
            div {
                display: inline-block;
                width: 20vw;
            }
        }
    }
    li:first-child {
        margin: 0;
        height: 10.9vw;
        padding: 0 4vw;
        background-color: #fafcff;
        font-size: 13px;
        color: #a6a6a6;
        border-top: 1px solid #d4e5ff;
        border-bottom: 1px solid #d4e5ff;
        .itemName {
            padding-left: 2px;
        }
    }
    li:last-child {
        border-bottom: none;
    }
}
.itemBox{
    padding-bottom: 3.3vw;
}
.itemDetails {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 9.3vw;
    margin: 0 4vw 2vw 4vw;
    padding: 0 6vw;
    background: #f7f7f7;
    background-color: 6px;
    font-size: 14px;
    div{
        flex: 1;
        text-align: center;
    }
    div:first-child{
        text-align: left;
    }
    .yesPer{
        div{
            float: right;
            width: 16vw;
            text-align: center;
        }
    }
}
.van-tabs {
    /deep/.van-tab{
        font-size: 16px;
    }
    /deep/.van-tabs__wrap {
        border-bottom: 1px solid #dedede;
    }
    /deep/.van-tab--active {
        color: #e5323b;
    }
    /deep/.van-tabs__line {
        width: 7.2vw !important;
    }
    .box {
        padding: 5vw 0 5vw 4vw;
        background-color: #fff;
    }
}
</style>





// WEBPACK FOOTER //
// src/jxwx/components/chargeDetails.vue